import React, { useEffect, useState, useContext } from "react";
import {
  DialogTitle, Box, Button, FormControlLabel, Checkbox, Radio, RadioGroup, IconButton, Accordion, AccordionSummary, AccordionDetails, Typography, useTheme, CircularProgress, Grid, Card, CardContent, CardActions, Avatar, Tooltip, TextField, Dialog, DialogContent
} from "@mui/material";
import { tokens } from "../../theme";
import { shuffle } from 'lodash';
import { API, Auth } from "aws-amplify";
import { learncardsContext } from "../../App";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Link } from "react-router-dom";
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';



import chroma from "chroma-js";

import SettingsIcon from '@mui/icons-material/Settings';
import Modal from '@mui/material/Modal';

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { loading, setLoading, cardData, setCardData, selectedOption, exerciseChecked, setExerciseChecked } = useContext(learncardsContext);

  const [selectedCard, setSelectedCard] = useState(null); // State to track the selected card
  const [cardCounts, setCardCounts] = useState({}); // State to store hit and mis counts for each card
  const [evaluatingCard, setEvaluatingCard] = useState(null); // State to track which card is being evaluated
  const [startNumber, setStartNumber] = useState(0); // State to store the start number
  const [endNumber, setEndNumber] = useState(100); // State to store the end number
  const [removeChecked, setRemoveChecked] = useState(true); // State to track if "remove" checkbox is checked

  const [cardsToRemove, setCardsToRemove] = useState([]); // State to track cards to remove with fade out effect

  const [sortMode, setSortMode] = useState('default'); // 'default' | 'color' | 'alpha' | 'longestAgo'




  // const [maxHits, setMaxHits] = useState(null); // State to hold the maximum number of hits
  // const [minMisses, setMinMisses] = useState(null); // State to hold the minimum number of misses

  const [showSettings, setShowSettings] = useState(false); // State to control whether to show additional settings

  const [imageData, setImageData] = useState(null); // State to hold the image data
  const [openImageModal, setOpenImageModal] = useState(false); // State to handle the modal open status

  const [initialLoad, setInitialLoad] = useState(false); // State to handle the modal open status

  const [openSettingsModal, setOpenSettingsModal] = useState(false);

  const navigate = useNavigate();


  // Function to calculate the background color based on sorting formula
  const calculateBackgroundColor2 = (hit, mis) => {
    const formula = calculateSortingFormula(hit, mis);
    // Define your color thresholds and corresponding colors here
    if (formula >= 2) {
      return "#4CAF50"; // Green color for high score
    } else if (formula >= 1) {
      return "#FFEB3B"; // Yellow color for medium score
    } else {
      return "#F44336"; // Red color for low score
    }
  };

  // Function to calculate the background color based on sorting formula
  const calculateBackgroundColor = (hit, mis) => {
    const formula = calculateSortingFormula(hit, mis);
    // Interpolate between colors based on the formula value
    const scale = chroma.scale(['#F44336', '#FFEB3B', '#4CAF50']).domain([-1, 0, 1]);
    return scale(formula).hex();
  };
  // Function to sort cards alphabetically
  // Function to sort cards alphabetically
  const sortCardsByAlpha = (cards) => {
    if (!Array.isArray(cards)) {
      return []; // Return an empty array if cards is not an array
    }
    return cards.slice().sort((a, b) => {
      const nrA = a.nr ? a.nr.toString() : '';
      const nrB = b.nr ? b.nr.toString() : '';
      return nrA.localeCompare(nrB); // Convert to string before comparing
    });
  };

  const getLastReviewTime = (card) => {
    const times = [card.hit_date, card.mis_date]
      .filter((d) => d && d !== "")
      .map((d) => new Date(d).getTime())
      .filter((t) => !Number.isNaN(t));
    if (times.length === 0) return null;
    return Math.max(...times);
  };

  const sortCardsByLongestAgo = (cards) => {
    if (!Array.isArray(cards)) {
      return [];
    }
    return cards.slice().sort((a, b) => {
      const timeA = getLastReviewTime(a);
      const timeB = getLastReviewTime(b);
      if (timeA === null && timeB === null) return 0;
      if (timeA === null) return -1;
      if (timeB === null) return 1;
      return timeA - timeB;
    });
  };

  // Function to calculate the sorting formula
  const calculateSortingFormula2 = (hit, mis) => {
    return ((hit - mis) * 100) / (hit + mis);
  };

  // Function to calculate the sorting formula
  const calculateSortingFormula = (hit, mis) => {
    // if (hit == "") {
    //   hit = 0;
    // }
    // if (mis == "") {
    //   mis = 0;
    // }
    // if ((hit + mis) == 0) {
    //   return "";
    // }
    return (hit - mis) / (hit + mis);
    //return hit / mis;
  };


  // Function to sort cards by formula
  const sortCardsByFormula = (cards) => {
    if (!Array.isArray(cards)) {
      return []; // Return an empty array if cards is not an array
    }
    return cards.sort((a, b) => {
      const formulaA = calculateSortingFormula(cardCounts[a.id]?.hit, cardCounts[a.id]?.mis);
      const formulaB = calculateSortingFormula(cardCounts[b.id]?.hit, cardCounts[b.id]?.mis);
      // Check if formulaA or formulaB is NaN
      if (isNaN(formulaA) && isNaN(formulaB)) {
        return 0; // Treat two NaNs as equal
      } else if (isNaN(formulaA)) {
        return -1; // Place NaNs at the end
      } else if (isNaN(formulaB)) {
        return 1; // Place NaNs at the end
      }
      //return formulaB - formulaA; // Descending order      
      return formulaA - formulaB; // Ascending order
    });
  };
  // Handler for "remove" checkbox change
  const handleRemoveCheckboxChange = (event) => {
    setRemoveChecked(event.target.checked);
  };

  const handleExerciseCheckboxChange = (event) => {
    setExerciseChecked(event.target.checked);
  };

  useEffect(() => {
    // Initialize hit and mis counts for each card from cardData
    // don't do when excercise mode otherwise setCardCounts gets refreshed
    if (cardData && cardData.data) {
      const counts = {};
      cardData.data.forEach((item) => {
        counts[item.id] = { hit: item.hit, mis: item.mis };
      });
      setCardCounts(counts);
    }
  }, [cardData]);


  // useEffect(() => {
  //   if (!initialLoad) {
  //     setInitialLoad(true);
  //     if (cardData && cardData.data) {
  //       const allNumbers = cardData.data.every(item => !isNaN(Number(item.nr)));
  //       setSortByAlpha(!allNumbers);
  //       setSortByFormula(allNumbers);
  //     }

  //   }
  // }, [selectedOption]);


  const handleCardClick = async (randomId) => {
    // Check if the card is being selected (flipped to show the back)
    const isSelected = selectedCard === randomId;
    setSelectedCard(isSelected ? null : randomId);

    if (!isSelected) {
      // Check if back1 contains "jpg" or "png"
      const cardWithImage = cardsToDisplay.find(card => card.id === randomId && (card.back1.includes("jpg") || card.back1.includes("png")));

      if (cardWithImage) {
        try {
          const session = await Auth.currentSession();
          const accessToken = session.getAccessToken().getJwtToken();
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const route = `/image?selectie=${selectedOption}&filename=${cardWithImage.back1}&id=${cardWithImage.id}`;
          const response = await API.get("FRONTEND_HTTP_API", route, {
            headers: headers,
          });
          if (response && response.image_data_base64) {
            // Handle the response
            const { image_data_base64, content_type } = response;
            setImageData(`data:${content_type};base64,${image_data_base64}`);
            setOpenImageModal(true); // Open the modal with the image
          } else {
            console.error('Failed to fetch image:', response.statusText);
          }
        } catch (error) {
          console.error('Error fetching image:', error);
        }
      }
    } else {
      setImageData(null); // Clear image data if the card is being deselected
    }
  };


  const handleThumbUpClick = async (id) => {
    try {
      await callEvaluateAPI(id, "+");
      if (exerciseChecked) {
        // Update the card counts locally 
        setCardCounts(prevCounts => ({
          ...prevCounts,
          [id]: {
            hit: (prevCounts[id]?.hit || 0) + 1,
            mis: prevCounts[id]?.mis || 0
          }
        }));

        // If  exerciseChecked is true, remove the card anyways
        if (exerciseChecked) {
          setCardsToRemove(prevCards => [...prevCards, id]);

          setTimeout(() => {
            setCardData(prevCardData => ({
              ...prevCardData,
              data: prevCardData.data.filter(card => card.id !== id)
            }));
          }, 500);
        }
      }
    } catch (error) {
      console.error("Error evaluating card:", error);
    }
  };
  const handleThumbDownClick = async (id) => {
    try {
      await callEvaluateAPI(id, "-");
      if (exerciseChecked) {
        setCardCounts(prevCounts => {
          const newCounts = {
            ...prevCounts,
            [id]: {
              hit: prevCounts[id]?.hit || 0,
              mis: (prevCounts[id]?.mis || 0) + 1
            }
          };

          // Update cardData within this callback to ensure we have the latest cardCounts
          setCardData(prevCardData => {
            const index = prevCardData.data.findIndex(card => card.id === id);
            const updatedData = [...prevCardData.data];
            const movedCard = { ...updatedData[index], mis: newCounts[id].mis };
            updatedData.splice(index, 1);
            updatedData.push(movedCard);

            return {
              ...prevCardData,
              data: updatedData
            };
          });

          return newCounts;
        });
      }
    } catch (error) {
      console.error("Error evaluating card:", error);
    }
  };




  const callEvaluateAPI = async (id, evaluation) => {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken().getJwtToken();
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };
    let evaluation_mode = "EXERCISE"
    if (!exerciseChecked) {
      evaluation_mode = "TRACKING"
    }
    const route = "/evaluate?selectie=" + selectedOption + "&evaluation_mode=" + evaluation_mode;



    const response = await API.post("FRONTEND_HTTP_API", route, {
      body: {
        id: id,
        evaluation: evaluation
      },
      headers: headers,
    });

    if (!exerciseChecked) { // if tracking do some housekeeping
      setEvaluatingCard(id);
      setCardCounts(prevCounts => ({
        ...prevCounts,
        [id]: { hit: response.hit, mis: response.mis }
      }));

      if (removeChecked) {
        setCardsToRemove(prevCards => [...prevCards, id]);

        setTimeout(() => {
          setCardData(prevCardData => ({
            ...prevCardData,
            data: prevCardData.data.filter(card => card.id !== id)
          }));
        }, 500);
      } else {
        setCardData(prev => ({
          ...prev,
          data: prev.data.map(card =>
            card.id === id
              ? {
                  ...card,
                  hit: response.hit,
                  mis: response.mis,
                  ...(evaluation === '+'
                    ? { hit_date: new Date().toISOString() }
                    : { mis_date: new Date().toISOString() }),
                }
              : card
          ),
        }));
      }
      setEvaluatingCard(null);
    }
  };

  // Filter cards based on start and end number    
  const filteredCards = cardData && cardData.data && cardData.data.filter(item => {
    const cardNumber = parseInt(item.nr);
    const hits = cardCounts[item.id]?.hit;
    const misses = cardCounts[item.id]?.mis;

    // Check if startNumber and endNumber are not numbers
    const areNumbers = !isNaN(startNumber) && !isNaN(endNumber);

    // Apply filter condition based on startNumber and endNumber if both are numbers
    if (areNumbers) {
      return cardNumber >= startNumber && cardNumber <= endNumber;
    } else {
      // Return true if either startNumber or endNumber is not a number
      return true;
    }
  });


  const cardsToDisplay = (() => {
    switch (sortMode) {
      case 'alpha':
        return sortCardsByAlpha(filteredCards);
      case 'color':
        return sortCardsByFormula(filteredCards);
      case 'longestAgo':
        return sortCardsByLongestAgo(filteredCards);
      default:
        return filteredCards;
    }
  })();

  useEffect(() => {
    // Load startNumber and endNumber from local storage on component mount
    const storedStartNumber = localStorage.getItem('startNumber');
    const storedEndNumber = localStorage.getItem('endNumber');
    if (storedStartNumber) setStartNumber(parseInt(storedStartNumber));
    if (storedEndNumber) setEndNumber(parseInt(storedEndNumber));
  }, []);

  const handleStartNumberChange = (e) => {
    const value = parseInt(e.target.value);
    setStartNumber(value);
    localStorage.setItem('startNumber', value); // Save to local storage
  };

  const handleEndNumberChange = (e) => {
    const value = parseInt(e.target.value);
    setEndNumber(value);
    localStorage.setItem('endNumber', value); // Save to local storage
  };

  return (
    <Box m="20px">
      {/* Input fields for start and end numbers */}
      <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <TextField
            label="Start Nummer"
            type="number"
            value={startNumber}
            onChange={handleStartNumberChange}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: 10 }}
          />
          <TextField
            label="Eind Nummer"
            type="number"
            value={endNumber}
            onChange={handleEndNumberChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <IconButton
            onClick={() => navigate('/cards')}
            sx={{ mr: 2 }}
            aria-label="Add new card"
            title="Voeg nieuwe kaarten toe"
          >
            <AddBoxIcon
            />
          </IconButton>
        </Box>
        <Box display="flex" alignItems="center">

          <Button
            startIcon={<SettingsIcon />}
            onClick={() => setOpenSettingsModal(true)}
            sx={{ ml: 2 }}
          >
            Instellingen
          </Button>
        </Box>
      </Box>
      <Modal
        open={openSettingsModal}
        onClose={() => setOpenSettingsModal(false)}
        aria-labelledby="settings-modal-title"
        aria-describedby="settings-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}>
          <IconButton
            aria-label="close"
            onClick={() => setOpenSettingsModal(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="settings-modal-title" variant="h6" component="h2" mb={2}>
            Instellingen
          </Typography>
          <Box display="flex" flexDirection="column">
            <RadioGroup
              value={sortMode}
              onChange={(event) => setSortMode(event.target.value)}
            >
              <FormControlLabel value="default" control={<Radio />} label="Standaard volgorde" />
              <FormControlLabel value="color" control={<Radio />} label="Sorteer op kleur" />
              <FormControlLabel value="alpha" control={<Radio />} label="Sorteer alfabetisch" />
              <FormControlLabel value="longestAgo" control={<Radio />} label="Sorteer volgens langst" />
            </RadioGroup>
            <FormControlLabel
              control={<Checkbox checked={removeChecked} onChange={handleRemoveCheckboxChange} />}
              label="Verwijder kaart na evaluatie"
              sx={{ mt: 1 }}
            />
            {/* <TextField
              label="Max Hits"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginTop: 10, marginBottom: 10 }}
            />
            <TextField
              label="Min Misses"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginBottom: 10 }}
            /> */}
          </Box>
        </Box>
      </Modal>


      {cardsToDisplay && cardsToDisplay.length < 1 ? (
        <Button onClick={() => window.location.reload()} variant="contained" color="primary">
          Opnieuw beginnen
        </Button>
      ) : (null)}


      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fill, minmax(300px, 1fr))"
        gridAutoRows="140px"
        gap="20px"
      >

        {loading ? (
          <CircularProgress />
        ) : (
          cardsToDisplay && cardsToDisplay.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card
                className={`card-${item.id}`} // Add the random ID as a class name
                onClick={() => handleCardClick(item.id)}
                style={{ cursor: "pointer", backgroundColor: calculateBackgroundColor(cardCounts[item.id]?.hit, cardCounts[item.id]?.mis) }}
              >
                <CardContent style={{ display: "flex", alignItems: "center", minHeight: "80px" }}>
                  <Tooltip title={`Formula: ${calculateSortingFormula(cardCounts[item.id]?.hit, cardCounts[item.id]?.mis)}`}>
                    <Avatar sx={{ backgroundColor: 'rgba(255, 255, 255,0.7)' }}>
                      {evaluatingCard === item.id ? <CircularProgress /> : <LightbulbIcon sx={{ color: calculateBackgroundColor(cardCounts[item.id]?.hit, cardCounts[item.id]?.mis), transition: '0.3s', '&:hover': { color: 'green' } }} />}
                    </Avatar>
                  </Tooltip>
                  <Typography variant="body2" color="textPrimary" style={{ marginLeft: 10 }}>
                    {selectedCard === item.id ? (
                      <>
                        {/**  BACK OF CARD**/}  {/* Check if image data is available */}

                        <>
                          {/**<Typography variant="body2" color="textPrimary" style={{ fontWeight: "bold" }}>{item.front}</Typography>**/}
                          <Typography variant="body2" color="textPrimary" style={{ fontSize: '1.0rem' }}>
                            <span dangerouslySetInnerHTML={{ __html: item.back1 }} />
                          </Typography>
                          <Typography variant="body2" color="textPrimary" style={{ fontSize: '1.0rem' }}>
                            <span dangerouslySetInnerHTML={{ __html: item.back2 }} />
                          </Typography>
                          <Typography variant="body2" color="textPrimary" style={{ fontSize: '1.0rem' }}>
                            <span dangerouslySetInnerHTML={{ __html: item.back3 }} />
                          </Typography>
                        </>

                      </>
                    ) : (
                      <>
                        {/**  FRONT OF CARD**/}
                        <Typography variant="body2" color="textPrimary" style={{ fontWeight: "bold" }}>{isNaN(Number(item.nr)) ? `${item.nr}` : ''}</Typography>
                        <Typography variant="body2" color="textPrimary" style={{ fontSize: '1.0rem' }}>{item.front} {isNaN(Number(item.nr)) ? '' : `(${item.nr})`}</Typography>
                      </>
                    )}
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  {selectedCard === item.id ? (
                    <>
                      <IconButton>
                        <Tooltip title={`Draai om`}>
                          <AutorenewIcon />
                        </Tooltip>
                      </IconButton>
                      <IconButton
                        aria-label="thumb up"
                        onClick={(e) => {
                          e.stopPropagation(); // Stop event propagation
                          handleThumbUpClick(item.id);
                        }}
                      >
                        <Tooltip title={`Hit Date: ${item.hit_date}`}>
                          <ThumbUpOffAltIcon />
                        </Tooltip>
                        <Typography>{cardCounts[item.id]?.hit}</Typography>
                      </IconButton>
                      <IconButton
                        aria-label="thumb down"
                        onClick={(e) => {
                          e.stopPropagation(); // Stop event propagation
                          handleThumbDownClick(item.id);
                        }}
                      >
                        <Tooltip title={`Mis Date: ${item.mis_date}`}>
                          <ThumbDownOffAltIcon />
                        </Tooltip>
                        <Typography>{cardCounts[item.id]?.mis}</Typography>
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton aria-label="favorite">

                        <Tooltip title={`Draai om`}>
                          <AutorenewIcon />
                        </Tooltip>
                      </IconButton>

                    </>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ))
        )}
        <Dialog
          open={openImageModal}
          onClose={() => setOpenImageModal(false)}
          fullScreen
          PaperProps={{
            style: {
              width: '87vw',
              //height: '90vh',
              maxWidth: 'none',
              maxHeight: 'none',
              margin: 'auto'
            }
          }}
        >
          <DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => setOpenImageModal(false)}
              style={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {imageData && (
              <img src={imageData} alt="Card Image"
              //style={{ width: '100%', height: '100%' }} 
              />
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </Box >
  );
};

export default Dashboard;